/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard Service
 * This is the API documentation of the Dashboard service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { WidgetAxisRepresentation } from './WidgetAxisRepresentation';
import {
    WidgetAxisRepresentationFromJSON,
    WidgetAxisRepresentationFromJSONTyped,
    WidgetAxisRepresentationToJSON,
    WidgetAxisRepresentationToJSONTyped,
} from './WidgetAxisRepresentation';
import type { Resolution } from './Resolution';
import {
    ResolutionFromJSON,
    ResolutionFromJSONTyped,
    ResolutionToJSON,
    ResolutionToJSONTyped,
} from './Resolution';

/**
 * 
 * @export
 * @interface WidgetUpdateRequest
 */
export interface WidgetUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof WidgetUpdateRequest
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof WidgetUpdateRequest
     */
    generatedTitle?: string;
    /**
     * 
     * @type {Resolution}
     * @memberof WidgetUpdateRequest
     */
    resolution?: Resolution;
    /**
     * 
     * @type {string}
     * @memberof WidgetUpdateRequest
     */
    config?: string;
    /**
     * 
     * @type {number}
     * @memberof WidgetUpdateRequest
     */
    position?: number;
    /**
     * 
     * @type {string}
     * @memberof WidgetUpdateRequest
     */
    intervalName?: string;
    /**
     * 
     * @type {number}
     * @memberof WidgetUpdateRequest
     */
    intervalFrom?: number;
    /**
     * 
     * @type {number}
     * @memberof WidgetUpdateRequest
     */
    intervalTo?: number;
    /**
     * 
     * @type {Array<WidgetAxisRepresentation>}
     * @memberof WidgetUpdateRequest
     */
    axis?: Array<WidgetAxisRepresentation>;
}



/**
 * Check if a given object implements the WidgetUpdateRequest interface.
 */
export function instanceOfWidgetUpdateRequest(value: object): value is WidgetUpdateRequest {
    return true;
}

export function WidgetUpdateRequestFromJSON(json: any): WidgetUpdateRequest {
    return WidgetUpdateRequestFromJSONTyped(json, false);
}

export function WidgetUpdateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): WidgetUpdateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'title': json['title'] == null ? undefined : json['title'],
        'generatedTitle': json['generatedTitle'] == null ? undefined : json['generatedTitle'],
        'resolution': json['resolution'] == null ? undefined : ResolutionFromJSON(json['resolution']),
        'config': json['config'] == null ? undefined : json['config'],
        'position': json['position'] == null ? undefined : json['position'],
        'intervalName': json['intervalName'] == null ? undefined : json['intervalName'],
        'intervalFrom': json['intervalFrom'] == null ? undefined : json['intervalFrom'],
        'intervalTo': json['intervalTo'] == null ? undefined : json['intervalTo'],
        'axis': json['axis'] == null ? undefined : ((json['axis'] as Array<any>).map(WidgetAxisRepresentationFromJSON)),
    };
}

export function WidgetUpdateRequestToJSON(json: any): WidgetUpdateRequest {
    return WidgetUpdateRequestToJSONTyped(json, false);
}

export function WidgetUpdateRequestToJSONTyped(value?: WidgetUpdateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'title': value['title'],
        'generatedTitle': value['generatedTitle'],
        'resolution': ResolutionToJSON(value['resolution']),
        'config': value['config'],
        'position': value['position'],
        'intervalName': value['intervalName'],
        'intervalFrom': value['intervalFrom'],
        'intervalTo': value['intervalTo'],
        'axis': value['axis'] == null ? undefined : ((value['axis'] as Array<any>).map(WidgetAxisRepresentationToJSON)),
    };
}

